import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import LinesEllipsis from 'react-lines-ellipsis';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { EventBoundary, useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import Placeholder from './inspection-confirm-placeholder';
import CalendarButton from './calendar-button';
import * as styles from './inspection-confirm.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PlannerLink = _ref => {
  var dest = _ref.dest,
    children = _ref.children;
  return ___EmotionJSX("a", {
    href: dest,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};
PlannerLink.propTypes = {
  dest: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
var DATE_FORMAT = 'D';
var DAY_FORMAT = 'ddd';
var TIME_FORMAT = 'h:mm A';
var AddToCalendarButton = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX(CalendarButton, {
    appearance: "full",
    listing: props.listing,
    location: props.location,
    css: styles.calendarButton,
    onClick: () => {
      sendEvent('calendar-click');
      props.onClick();
    },
    fromModal: true
  });
};
AddToCalendarButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  listing: PropTypes.shape({
    url: PropTypes.string,
    price: PropTypes.string,
    beds: PropTypes.number,
    baths: PropTypes.number,
    parking: PropTypes.number
  }).isRequired,
  location: PropTypes.string.isRequired
};
var InspectionConfirm = _ref2 => {
  var plannerPageUrl = _ref2.plannerPageUrl,
    listing = _ref2.listing,
    startTime = _ref2.startTime,
    endTime = _ref2.endTime,
    location = _ref2.location,
    onCalendarClick = _ref2.onCalendarClick,
    onCloseClick = _ref2.onCloseClick;
  var startDate = moment(startTime);
  var endDate = endTime && moment(endTime);
  var date = startDate.format(DATE_FORMAT);
  var day = startDate.format(DAY_FORMAT).toUpperCase();
  var time = "".concat(startDate.format(TIME_FORMAT)).concat(endDate ? " - ".concat(endDate.format(TIME_FORMAT)) : '');
  return ___EmotionJSX(EventBoundary, {
    name: "inspection-confirm"
  }, ___EmotionJSX("div", {
    css: styles.confirmationContainer
  }, ___EmotionJSX("div", {
    css: styles.headerText
  }, "Got it!"), ___EmotionJSX("div", {
    css: styles.bodyText
  }, "Find this in your planner", ___EmotionJSX(PlannerLink, {
    dest: plannerPageUrl
  }, "Show me")), ___EmotionJSX(PlannerLink, null, ___EmotionJSX("div", {
    css: styles.confirmationCard
  }, listing !== null && listing !== void 0 && listing.imageUrl ? ___EmotionJSX("img", {
    css: styles.image,
    src: listing.imageUrl,
    alt: "",
    height: "115",
    width: "100%"
  }) : ___EmotionJSX(Placeholder, null), ___EmotionJSX("div", {
    css: styles.cardInfo
  }, ___EmotionJSX("div", {
    css: styles.date
  }, date, ___EmotionJSX("div", {
    css: styles.day
  }, day)), ___EmotionJSX("div", {
    css: styles.address
  }, ___EmotionJSX(LinesEllipsis, {
    text: location,
    maxLine: "2",
    ellipsis: "...",
    trimRight: true,
    basedOn: "letters"
  }), ___EmotionJSX("div", {
    css: styles.time
  }, time))))), ___EmotionJSX(AddToCalendarButton, {
    listing: listing,
    location: location,
    onClick: onCalendarClick
  }), ___EmotionJSX(Button, {
    css: styles.closeButton,
    appearance: "secondaryNeutral",
    onClick: onCloseClick,
    size: "small"
  }, "Thanks")));
};
InspectionConfirm.propTypes = {
  listing: PropTypes.shape({
    imageUrl: PropTypes.string
  }),
  location: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  plannerPageUrl: PropTypes.string,
  onCalendarClick: PropTypes.func,
  onCloseClick: PropTypes.func
};
InspectionConfirm.defaultProps = {
  listing: {
    imageUrl: ''
  },
  location: '',
  startTime: '',
  endTime: undefined,
  plannerPageUrl: '',
  onCalendarClick: () => {},
  onCloseClick: () => {}
};
export default InspectionConfirm;